import { ourDream } from '../../content/ourDream.js';

export function OurDream() {
  return (
    <section
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: 'clamp(46px,7vw,72px) clamp(18px,5vw,64px) 0',
      }}
    >
      <div
        style={{
          borderRadius: '28px',
          padding: 'clamp(28px,4.4vw,48px)',
          textAlign: 'center',
          background: 'var(--panel)',
          border: '1px solid var(--edge)',
          backdropFilter: 'blur(calc(var(--blur) * 1.6)) saturate(140%)',
          WebkitBackdropFilter: 'blur(calc(var(--blur) * 1.6)) saturate(140%)',
          boxShadow: 'var(--cardShadow)',
        }}
      >
        <div
          style={{
            font: "700 11.5px/1 'Plus Jakarta Sans',sans-serif",
            letterSpacing: '.09em',
            color: 'var(--faint)',
            textTransform: 'uppercase',
            marginBottom: '14px',
          }}
        >
          {ourDream.eyebrow}
        </div>
        <h2
          style={{
            margin: '0 auto 12px',
            maxWidth: '26ch',
            font: "800 clamp(26px,3.4vw,38px)/1.12 'Plus Jakarta Sans',sans-serif",
            letterSpacing: '-.03em',
            color: 'var(--ink)',
          }}
        >
          {ourDream.title}
        </h2>
        <p
          style={{
            margin: '0 auto',
            maxWidth: '52ch',
            font: "500 15px/1.55 'Plus Jakarta Sans',sans-serif",
            color: 'var(--muted)',
            textWrap: 'pretty',
          }}
        >
          {ourDream.body}
        </p>
      </div>
    </section>
  );
}
